import { Injectable } from '@angular/core';

import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private _httpService: HttpService
  ) { }

  getDataUser() {
    let userId = localStorage.getItem('uid');
    let headers = {
      'dataUsuario': 'true',
      'dataDirecciones': 'true',
      'dataHistorial': 'true'
    }
    return this._httpService.httpGet(`usuarios/usuario/${userId}`, headers);
  }
  
  getDataHistory() {
    let clientId = localStorage.getItem('clientId');
    let headers = {
      'clientId': clientId
    }
    return this._httpService.httpGet(`compras`, headers);
  }

  // Funciones HTTP
  updateName(data: any) {
    let userId = localStorage.getItem('uid');
    let headers = {
      'dataUsuario': 'true'
    }
    return this._httpService.httpPatch(`usuarios/usuario/${userId}`, data, headers);
  }

  closeSesion() {
    let data = {};
    return this._httpService.httpPost(`login/close`, data);
  }

}
